import { createContext, useContext } from "react";

import { isTransientIdentityRecheckFailure } from "@/components/auth/templateEditorRecovery";

export const ApiHealthRecoveryContext = createContext({
  isDown: false,
  recoveryGeneration: 0,
});

export const useApiHealthRecovery = () => useContext(ApiHealthRecoveryContext);

/**
 * An outage can explain an idempotent transport/server failure, but must not
 * conceal a denial or bypass a rate-limit window.
 */
export const isOutageRelatedAccessFailure = (error: unknown): boolean =>
  isTransientIdentityRecheckFailure(error) &&
  typeof error === "object" &&
  error !== null &&
  "status" in error &&
  error.status !== 429;
